import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { Cultures } from '@costar/i18n-2.0';

var CentralPreferenceIdentifier = /*#__PURE__*/function (CentralPreferenceIdentifier) {
  CentralPreferenceIdentifier["RateBasis"] = "RateBasis";
  CentralPreferenceIdentifier["Measurement"] = "Measurement";
  CentralPreferenceIdentifier["DistanceUnit"] = "DistanceUnit";
  CentralPreferenceIdentifier["AreaUnit"] = "AreaUnit";
  CentralPreferenceIdentifier["Culture"] = "Culture";
  CentralPreferenceIdentifier["STROverrideCulture"] = "STROverrideCulture";
  CentralPreferenceIdentifier["Currency"] = "Currency";
  CentralPreferenceIdentifier["BuxtonEntitlements"] = "BuxtonEntitlements";
  CentralPreferenceIdentifier["EmailAlerts"] = "EmailAlerts";
  CentralPreferenceIdentifier["SuiteFilterMarkets"] = "SuiteFilterMarkets";
  CentralPreferenceIdentifier["RegionUK"] = "RegionUK";
  CentralPreferenceIdentifier["StateUS"] = "StateUS";
  CentralPreferenceIdentifier["ProvinceCA"] = "ProvinceCA";
  CentralPreferenceIdentifier["SuiteFilterMode"] = "SuiteFilterMode";
  CentralPreferenceIdentifier["SuiteResultPageSize"] = "SuiteResultPageSize";
  CentralPreferenceIdentifier["DomainUse"] = "DomainUse";
  CentralPreferenceIdentifier["AccountCreationDomain"] = "AccountCreationDomain";
  CentralPreferenceIdentifier["NewsFeedContent"] = "NewsFeedContent";
  CentralPreferenceIdentifier["SuiteDemographicRadiusCol1Ca"] = "SuiteDemographicRadiusCol1Ca";
  CentralPreferenceIdentifier["SuiteDemographicRadiusCol2Ca"] = "SuiteDemographicRadiusCol2Ca";
  CentralPreferenceIdentifier["SuiteDemographicRadiusCol3Ca"] = "SuiteDemographicRadiusCol3Ca";
  CentralPreferenceIdentifier["SuiteDemographicRadiusCol1"] = "SuiteDemographicRadiusCol1";
  CentralPreferenceIdentifier["SuiteDemographicRadiusCol2"] = "SuiteDemographicRadiusCol2";
  CentralPreferenceIdentifier["SuiteDemographicRadiusCol3"] = "SuiteDemographicRadiusCol3";
  CentralPreferenceIdentifier["LocationTooltip"] = "LocationTooltip";
  return CentralPreferenceIdentifier;
}({});
var CentralPreferenceSuiteFilterMode = /*#__PURE__*/function (CentralPreferenceSuiteFilterMode) {
  CentralPreferenceSuiteFilterMode[CentralPreferenceSuiteFilterMode["Global"] = 1] = "Global";
  CentralPreferenceSuiteFilterMode[CentralPreferenceSuiteFilterMode["US"] = 2] = "US";
  CentralPreferenceSuiteFilterMode[CentralPreferenceSuiteFilterMode["GB"] = 3] = "GB";
  CentralPreferenceSuiteFilterMode[CentralPreferenceSuiteFilterMode["CA"] = 4] = "CA";
  return CentralPreferenceSuiteFilterMode;
}({});
var CentralPreferenceSuiteResultPageSize = /*#__PURE__*/function (CentralPreferenceSuiteResultPageSize) {
  CentralPreferenceSuiteResultPageSize[CentralPreferenceSuiteResultPageSize["Twenty"] = 20] = "Twenty";
  CentralPreferenceSuiteResultPageSize[CentralPreferenceSuiteResultPageSize["Fifty"] = 50] = "Fifty";
  CentralPreferenceSuiteResultPageSize[CentralPreferenceSuiteResultPageSize["SeventyFive"] = 75] = "SeventyFive";
  CentralPreferenceSuiteResultPageSize[CentralPreferenceSuiteResultPageSize["OneHundred"] = 100] = "OneHundred";
  return CentralPreferenceSuiteResultPageSize;
}({});
var CentralPreferenceCulture = /*#__PURE__*/function (CentralPreferenceCulture) {
  CentralPreferenceCulture[CentralPreferenceCulture["EnglishUnitedStates"] = 1] = "EnglishUnitedStates";
  CentralPreferenceCulture[CentralPreferenceCulture["EnglishCanada"] = 2] = "EnglishCanada";
  CentralPreferenceCulture[CentralPreferenceCulture["EnglishUnitedKingdom"] = 3] = "EnglishUnitedKingdom";
  CentralPreferenceCulture[CentralPreferenceCulture["FrenchCanada"] = 4] = "FrenchCanada";
  CentralPreferenceCulture[CentralPreferenceCulture["FrenchFrance"] = 5] = "FrenchFrance";
  CentralPreferenceCulture[CentralPreferenceCulture["SpanishSpain"] = 6] = "SpanishSpain";
  CentralPreferenceCulture[CentralPreferenceCulture["GermanGermany"] = 7] = "GermanGermany";
  CentralPreferenceCulture[CentralPreferenceCulture["DutchNetherlands"] = 8] = "DutchNetherlands";
  CentralPreferenceCulture[CentralPreferenceCulture["ItalianItaly"] = 9] = "ItalianItaly";
  CentralPreferenceCulture[CentralPreferenceCulture["PortuguesePortugal"] = 10] = "PortuguesePortugal";
  CentralPreferenceCulture[CentralPreferenceCulture["SpanishMexico"] = 11] = "SpanishMexico";
  CentralPreferenceCulture[CentralPreferenceCulture["SpanishLatinAmerica"] = 12] = "SpanishLatinAmerica";
  CentralPreferenceCulture[CentralPreferenceCulture["StretchEnglish"] = 1001] = "StretchEnglish";
  CentralPreferenceCulture[CentralPreferenceCulture["MicroCodeEnglish"] = 1004] = "MicroCodeEnglish";
  CentralPreferenceCulture[CentralPreferenceCulture["PolishPolish"] = 16] = "PolishPolish";
  CentralPreferenceCulture[CentralPreferenceCulture["SwedishSweden"] = 17] = "SwedishSweden";
  CentralPreferenceCulture[CentralPreferenceCulture["NorwegianBokmal"] = 22] = "NorwegianBokmal";
  CentralPreferenceCulture[CentralPreferenceCulture["NorwegianNynorsk"] = 23] = "NorwegianNynorsk";
  CentralPreferenceCulture[CentralPreferenceCulture["DanishDanish"] = 25] = "DanishDanish";
  CentralPreferenceCulture[CentralPreferenceCulture["FinnishFinish"] = 27] = "FinnishFinish";
  CentralPreferenceCulture[CentralPreferenceCulture["CzechCzech"] = 28] = "CzechCzech";
  CentralPreferenceCulture[CentralPreferenceCulture["SlovakSlovak"] = 29] = "SlovakSlovak";
  CentralPreferenceCulture[CentralPreferenceCulture["HungarianHungarian"] = 30] = "HungarianHungarian";
  CentralPreferenceCulture[CentralPreferenceCulture["CroatianCroatian"] = 31] = "CroatianCroatian";
  CentralPreferenceCulture[CentralPreferenceCulture["JapaneseJapan"] = 32] = "JapaneseJapan";
  CentralPreferenceCulture[CentralPreferenceCulture["SimplifiedChinese"] = 33] = "SimplifiedChinese";
  CentralPreferenceCulture[CentralPreferenceCulture["EnglishAustralia"] = 34] = "EnglishAustralia";
  return CentralPreferenceCulture;
}({});
var CentralPreferenceAreaUnit = /*#__PURE__*/function (CentralPreferenceAreaUnit) {
  CentralPreferenceAreaUnit[CentralPreferenceAreaUnit["SF"] = 1] = "SF";
  CentralPreferenceAreaUnit[CentralPreferenceAreaUnit["SM"] = 2] = "SM";
  CentralPreferenceAreaUnit[CentralPreferenceAreaUnit["AC"] = 3] = "AC";
  CentralPreferenceAreaUnit[CentralPreferenceAreaUnit["HA"] = 4] = "HA";
  return CentralPreferenceAreaUnit;
}({});
var CentralPreferenceMeasurementUnit = /*#__PURE__*/function (CentralPreferenceMeasurementUnit) {
  CentralPreferenceMeasurementUnit[CentralPreferenceMeasurementUnit["FT"] = 1] = "FT";
  CentralPreferenceMeasurementUnit[CentralPreferenceMeasurementUnit["M"] = 2] = "M";
  return CentralPreferenceMeasurementUnit;
}({});
var CentralPreferenceDistanceUnit = /*#__PURE__*/function (CentralPreferenceDistanceUnit) {
  CentralPreferenceDistanceUnit[CentralPreferenceDistanceUnit["MI"] = 1] = "MI";
  CentralPreferenceDistanceUnit[CentralPreferenceDistanceUnit["KM"] = 2] = "KM";
  return CentralPreferenceDistanceUnit;
}({});
var CentralPreferenceRateBasis = /*#__PURE__*/function (CentralPreferenceRateBasis) {
  CentralPreferenceRateBasis[CentralPreferenceRateBasis["Monthly"] = 1] = "Monthly";
  CentralPreferenceRateBasis[CentralPreferenceRateBasis["Yearly"] = 2] = "Yearly";
  return CentralPreferenceRateBasis;
}({});
var cultureIdToStringMapping = Object.values(CentralPreferenceCulture).reduce(function (acc, cur) {
  if (typeof cur == 'number') {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, cur, Cultures[CentralPreferenceCulture[cur]]));
  }
  return acc;
}, {});

export { CentralPreferenceAreaUnit, CentralPreferenceCulture, CentralPreferenceDistanceUnit, CentralPreferenceIdentifier, CentralPreferenceMeasurementUnit, CentralPreferenceRateBasis, CentralPreferenceSuiteFilterMode, CentralPreferenceSuiteResultPageSize, cultureIdToStringMapping };
//# sourceMappingURL=types.esm.js.map
